import { store } from './store';
import { Observable } from 'rxjs/Observable';
import { Subscriber } from 'rxjs/Subscriber';
import queryString from 'query-string';
import io from 'socket.io-client';
import Polyline from '@mapbox/polyline';
import * as Colors from 'material-ui/styles/colors';

import { empresaUrl, coreUrl, env_production, array_colors } from './constants';

export function getCurrentPath(storeData) {
  return (storeData || store).getState().getIn(['routing', 'locationBeforeTransitions', 'pathname']);
}

export function listFindById(list, id, indexOnly) {
  try {
    let index = list.findIndex(function (item) {
      if (item.id === id) return item;
    });
    if (indexOnly) return index;
    else return list.get(index);
  } catch (e) {
    return null;
  }
}

export function listFindBy(list, index, indexValue, indexOnly) {
  try {
    let listIndex = list.findIndex(function (item) {
      if (item.get(index) === indexValue) return item;
    });
    if (indexOnly) return index;
    else return list.get(listIndex);
  } catch (e) {
    return null;
  }
}

export function listFindByMapId(list, id, indexOnly) {
  try {
    let index = list.findIndex(function (item) {
      if (item.get('id') === id) return item;
    });
    if (indexOnly) return index;
    else return list.get(index);
  } catch (e) {
    return null;
  }
}

export function request(action) {
  let req = {
    method: action.epic.method,
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 5000,
  };
  if (action.epic.method === 'POST' || action.epic.method === 'PUT' || action.epic.method === 'PATCH') {
    req.body = JSON.stringify(action.payload);
    req.url = getUrlRequest(action.epic.url, null, action.epic.toCore);
  } else req.url = getUrlRequest(action.epic.url, action.payload, action.epic.toCore);
  console.log('env_production', env_production);
  if (!env_production) console.log('req', req);
  return req;
}

export function getUrlRequest(url, meta, toCore) {
  var parameters = {},
    urlRequest = toCore ? coreUrl + '/api/' : empresaUrl + '/api/',
    access_token = store.getState().getIn(['user', 'access_token']);
  for (var key in meta) if (typeof meta[key] == 'object') meta[key] = JSON.stringify(meta[key]);
  parameters = {
    ...meta,
  };
  //console.log(parameters);
  if (access_token) parameters.access_token = access_token;
  return urlRequest + url + '?' + queryString.stringify(parameters);
}

export function logout() {
  localStorage.removeItem('access_token');
  localStorage.removeItem('userId');
}

export class SocketConnection {
  constructor() {
    console.log('Sockets -> Conectando...', empresaUrl);
    this.socket = io(empresaUrl, {
      path: '/socket',
      reconnection: true,
      forceNew: true,
      reconnectionDelay: 3000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: Infinity,
    });
    !env_production && this.socket.on('connect', () => console.log('Sockets -> Conectado'));
    this.socket.on('disconnect', (data) => {
      !env_production && console.log('Sockets -> Desconectado', data);
      data != 'ping timeout' && setTimeout(() => this.socket.connect(), 5000);
    });
    this.socket.on('connect_error', (data) => {
      !env_production && console.log('Sockets -> Connection Failed', data);
      setTimeout(() => this.socket.connect(), 5000);
    });
  }
  listen$(channel) {
    return Observable.create((observer) => {
      this.socket.on(channel, (data) => observer.next(data));
      this.socket.on('socket_error', (data) => {
        !env_production && console.log('Sockets -> Error', data);
        observer.error(data);
      });
      return () => {
        this.socket.close && this.socket.close();
        observer.complete();
      };
    });
  }
  emitter(type, payload) {
    this.socket.connected && this.socket.emit(type, payload);
    return true;
  }
}

export const fromEventSource = (url, openObserver) => {
  return new Observable((observer) => {
    const open = new Subscriber(openObserver);
    const source = new EventSource(getUrlRequest(url, { _format: 'event-stream' }));

    const onOpen = (event) => {
      open.next(event);
      open.complete();
    };

    const onError = (event) => {
      if (event.readyState === EventSource.CLOSED) {
        observer.complete();
      } else {
        observer.error(event);
      }
    };

    const onMessage = (event) => {
      observer.next(event.data);
    };

    source.addEventListener('open', onOpen, false);
    source.addEventListener('error', onError, false);
    source.addEventListener('data', onMessage, false);

    return () => {
      source.removeEventListener('open', onOpen, false);
      source.removeEventListener('error', onError, false);
      source.removeEventListener('data', onMessage, false);
      source.close();
    };
  });
};

export const traducirAccion = (accion) => {
  let accionTraducida = {
    icon: 'bell-o',
    accion: '',
    color: Colors.yellow500,
  };
  switch (accion) {
    case 'reserva_creada':
      accionTraducida = {
        icon: 'ticket',
        accion: 'Nueva reserva',
        color: Colors.green500,
      };
      break;
    case 'reserva_concretada':
      accionTraducida = {
        icon: 'ticket',
        accion: 'Reserva concretada',
        color: Colors.blue500,
      };
      break;
    case 'reserva_concretada_chofer':
      accionTraducida = {
        icon: 'ticket',
        accion: 'Reserva concretada por chofer',
        color: Colors.blue500,
      };
      break;
    case 'ingreso_al_sistema':
      accionTraducida = {
        icon: 'sign-in',
        accion: 'Inicio Sesion',
        color: Colors.blue500,
      };
      break;
    case 'reserva_modificada':
      accionTraducida = {
        icon: 'ticket',
        accion: 'Reserva modificada',
        color: Colors.yellow500,
      };
      break;
    case 'vehiculo_modificado':
      accionTraducida = {
        icon: 'taxi',
        accion: 'Vehiculo modificado',
        color: Colors.yellow500,
      };
      break;
    case 'vehiculo_creado':
      accionTraducida = {
        icon: 'taxi',
        accion: 'Vehiculo creado',
        color: Colors.green500,
      };
      break;
    case 'vehiculo_eliminado':
      accionTraducida = {
        icon: 'taxi',
        accion: 'Vehiculo eliminado',
        color: Colors.red500,
      };
      break;
    case 'reserva_cancelada':
      accionTraducida = {
        icon: 'ticket',
        accion: 'Reserva cancelada',
        color: Colors.red500,
      };
      break;
    case 'reserva_eliminada':
      accionTraducida = {
        icon: 'trash',
        accion: 'Reserva eliminada',
        color: Colors.red500,
      };
      break;
    case 'abono_eliminado':
      accionTraducida = {
        icon: 'trash',
        accion: 'Abono eliminado',
        color: Colors.red500,
      };
      break;
    case 'abono_creado':
      accionTraducida = {
        accion: 'Abono creado',
        icon: 'plus',
        color: Colors.green500,
      };
      break;
    case 'abono_editado':
      accionTraducida = {
        accion: 'Abono modificado',
      };
      break;
    case 'reserva_creada_chofer':
      accionTraducida = {
        accion: 'Nueva reserva chofer',
        icon: 'bus',
        color: Colors.green500,
      };
      break;
    case 'parada_creada':
      accionTraducida = {
        accion: 'Parada Creada',
        icon: 'map-marker',
        color: Colors.green500,
      };
      break;
    case 'parada_modificada':
      accionTraducida = {
        accion: 'Parada modificada',
        icon: 'map-marker',
        color: Colors.yellow500,
      };
      break;
    case 'parada_eliminada':
      accionTraducida = {
        accion: 'Parada eliminada',
        icon: 'map-marker',
        color: Colors.red500,
      };
      break;
    case 'usuario_creado':
      accionTraducida = {
        accion: 'Usuario creado',
        icon: 'user',
        color: Colors.green500,
      };
      break;
    case 'usuario_modificado':
      accionTraducida = {
        accion: 'Usuario modificado',
        icon: 'user',
        color: Colors.yellow500,
      };
      break;
    case 'reservas_automaticas_modificadas':
      accionTraducida = {
        accion: 'Reserva automatica modificada',
        icon: 'bell',
        color: Colors.yellow500,
      };
      break;
    case 'reserva_automatica_modificada_cliente':
      accionTraducida = {
        accion: 'Reserva automatica modificada por cliente',
        icon: 'bell',
        color: Colors.yellow500,
      };
      break;
    case 'reserva_automatica_modificada':
      accionTraducida = {
        accion: 'Reserva automatica modificada',
        icon: 'bell',
        color: Colors.yellow500,
      };
      break;
    case 'reserva_automatica_creada':
      accionTraducida = {
        accion: 'Reserva automatica creada',
        icon: 'bell',
        color: Colors.green500,
      };
      break;
    case 'reservas_automaticas_eliminada':
      accionTraducida = {
        accion: 'Reserva automatica eliminada',
        icon: 'bell',
        color: Colors.red500,
      };
      break;
    case 'feriado_creado':
      accionTraducida = {
        accion: 'Feriado creado',
        icon: 'calendar-minus-o',
        color: Colors.green500,
      };
      break;
    case 'feriado_modificado':
      accionTraducida = {
        accion: 'Feriado modificado',
        icon: 'calendar-minus-o',
        color: Colors.yellow500,
      };
      break;
    case 'feriado_eliminado':
      accionTraducida = {
        accion: 'Feriado eliminado',
        icon: 'calendar-minus-o',
        color: Colors.red500,
      };
      break;
    case 'reserva_creada_cliente':
      accionTraducida = {
        accion: 'Nueva reserva cliente',
        icon: 'ticket',
        color: Colors.green500,
      };
      break;
    case 'reserva_cancelada_cliente':
      accionTraducida = {
        accion: 'Reserva cancelada cliente',
        icon: 'ticket',
        color: Colors.red500,
      };
      break;
    case 'reserva_confirmada_cliente':
      accionTraducida = {
        accion: 'Reserva confirmada cliente',
        icon: 'check-square',
        color: Colors.green500,
      };
      break;
    case 'reserva_modificada_cliente':
      accionTraducida = {
        icon: 'ticket',
        accion: 'Reserva modificada cliente',
        color: Colors.yellow500,
      };
      break;
    case 'viaje_creado':
      accionTraducida = {
        icon: 'bus',
        accion: 'Viaje creado',
        color: Colors.green500,
      };
      break;
    case 'viaje_eliminado':
      accionTraducida = {
        accion: 'Viaje eliminado',
        icon: 'bus',
        color: Colors.red500,
      };
      break;
    case 'viaje_asignado':
      accionTraducida = {
        accion: 'Viaje asignado',
        icon: 'bus',
      };
      break;
    case 'viaje_modificado':
      accionTraducida = {
        accion: 'Viaje modificado',
        icon: 'bus',
        color: Colors.yellow500,
      };
      break;
    case 'trayecto_creado':
      accionTraducida = {
        accion: 'Trayecto creado',
        icon: 'map',
        color: Colors.green500,
      };
      break;
    case 'trayecto_modificado':
      accionTraducida = {
        accion: 'Trayecto modificado',
        icon: 'map',
        color: Colors.yellow500,
      };
      break;
    case 'trayecto_generado':
      accionTraducida = {
        accion: 'Trayecto generado',
        icon: 'map',
      };
      break;
    case 'trayecto_eliminado':
      accionTraducida = {
        accion: 'Trayecto eliminado',
        icon: 'map',
        color: Colors.red500,
      };
      break;
    case 'usuario_eliminado':
      accionTraducida = {
        accion: '¡¡ATENCION!! USUARIO ELIMINADO, INFORME URGENTE',
        icon: 'trash',
        color: Colors.red500,
      };
      break;
    case 'usuario_cambio_de_roles':
      accionTraducida.accion = 'Cambio de rol';
      break;
    case 'rutina_modificada':
      accionTraducida = {
        accion: 'Rutina modificada',
        icon: 'calendar',
        color: Colors.red500,
      };
      break;
    case 'rutina_creada':
      accionTraducida = {
        accion: 'Rutina modificada',
        icon: 'calendar',
        color: Colors.green500,
      };
      break;
    case 'rutina_eliminada':
      accionTraducida = {
        accion: 'Rutina eliminada',
        icon: 'calendar',
        color: Colors.red500,
      };
      break;
    case 'mensaje_creado':
      accionTraducida = {
        accion: 'Mensaje creado',
        icon: 'commenting',
        color: Colors.green500,
      };
      break;
    case 'usuario_abonado_eliminado':
      accionTraducida = {
        accion: 'Abonado eliminado',
        icon: 'trash',
        color: Colors.red500,
      };
      break;
    default:
      accionTraducida.accion = accion;
  }
  return accionTraducida;
};

export const checkPermissions = (rolesPermitidos) => {
  if (!rolesPermitidos || typeof rolesPermitidos != 'object') throw 'Debe ingresar un array de roles.';
  if (store && store.getState)
    return (
      store.getState().getIn(['user', 'roles']) &&
      store
        .getState()
        .getIn(['user', 'roles'])
        .find((rol) => rolesPermitidos.find((rolPermitido) => rol == rolPermitido || rol == 'devAdmin'))
    );
  else return null;
};

export const getCookie = (name) => {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
};

export const setCookie = (name, value, days) => {
  let d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString();
};

export const deleteCookie = (name) => setCookie(name, '', -1);

export const filterByPolyline = (polyline, lng, lat, tolerance = 50) => {
  //Grados x 111139 = metros
  tolerance = tolerance / 111139;
  if (polyline && window.google && window.google.maps && window.google.maps.geometry)
    return window.google.maps.geometry.poly.isLocationOnEdge(new window.google.maps.LatLng(lat, lng), new window.google.maps.Polyline({ path: polyline }), tolerance);
  else return false;
};

export const formulaDistanciaEsfera = (lat1, lon1, lat2, lon2, unit) => {
  if (lat1 == lat2 && lon1 == lon2) {
    return 0;
  } else {
    var radlat1 = (Math.PI * lat1) / 180;
    var radlat2 = (Math.PI * lat2) / 180;
    var theta = lon1 - lon2;
    var radtheta = (Math.PI * theta) / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == 'K' || !unit) {
      dist = dist * 1.609344;
    }
    if (unit == 'N') {
      dist = dist * 0.8684;
    }
    return dist;
  }
};

export const calcularDistanciaEnPoly = (polyline, coordenada, onlyTotalDistance) => {
  if (!coordenada || !coordenada.latitude || !coordenada.longitude || !polyline) return 0;

  polyline = Polyline.decode(polyline).map((point) => ({ longitude: point[1], latitude: point[0] }));
  let distanciaTotal = 0;
  let distActual = 0;
  let distAnterior = 0;
  let coordData = onlyTotalDistance ? 0 : { distancia: null, distanciaPoly: 0 };

  polyline.some((coord, i) => {
    distActual = formulaDistanciaEsfera(coordenada.latitude, coordenada.longitude, coord.latitude, coord.longitude);

    if (i === 0) {
      if (!onlyTotalDistance) {
        coordData.index = i;
        coordData.distancia = distActual;
        coordData.distanciaPoly = distanciaTotal;
      } else coordData = distanciaTotal;
      distAnterior = distActual;
    } else if (distActual < distAnterior) {
      distAnterior = distActual;
      if (!onlyTotalDistance) {
        coordData.index = i;
        coordData.distancia = distActual;
        coordData.distanciaPoly = distanciaTotal;
      } else coordData = distanciaTotal;
    }
    if (distActual <= 0.01) return true;
    distanciaTotal += polyline[i + 1] ? formulaDistanciaEsfera(coord.latitude, coord.longitude, polyline[i + 1].latitude, polyline[i + 1].longitude) : 0;
  });
  return coordData;
};

export const pickAColor = (str) => {
  if (!str) return 'black';
  let sum = 0,
    i;
  for (let i = 0; i < str.length; i++) {
    sum += str.charCodeAt(i);
  }
  i = sum % array_colors.length;
  return array_colors[i];
};



// WEBPACK FOOTER //
// src/core/generalFunctions.js